import React from 'react';
import { Routes, Route, Navigate } from 'react-router';
import { ProtectedRoute } from '../components/ProtectedRoute';

// Client Components
import Dashboard from '../client/Dashboard';
import Accounts from '../client/accounts';
import Subscribers from '../client/statistics/Subscribers';
import Statistics from '../client/statistics/Statistic';
import Account from '../client/account';
import Proposals from '../client/subscribers/Proposals';
import Orders from '../client/subscribers/Orders';
import CreateOrder from '../client/subscribers/Proposals/create-order/index';
import Transactions from '../client/statistics/Transactions';
import Wallet from '../client/account/Wallet';
import Settings from '../client/account/Settings';
import CreateAccountPage from '../client/accounts/create-account/CreateAccountPage';
import AccountPage from '../client/accounts/account-page';
import RevshareOffers from '../client/revshare/offers';
import RevshareCampaigns from '../client/revshare/campaigns';
import RevshareBills from '../client/revshare/bills';

const ClientRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Client Routes - Require Client Authentication */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />

      <Route path="/dashboard" element={
        <ProtectedRoute requiredRole="client">
          <Dashboard />
        </ProtectedRoute>
      } />

      <Route path="/accounts" element={
        <ProtectedRoute requiredRole="client">
          <Accounts />
        </ProtectedRoute>
      } />

      <Route path="/accounts/create" element={
        <ProtectedRoute requiredRole="client">
          <CreateAccountPage />
        </ProtectedRoute>
      } />

      <Route path="/accounts/:id" element={
        <ProtectedRoute requiredRole="client">
          <AccountPage />
        </ProtectedRoute>
      } />

      <Route path="/accounts/:id/:tab" element={
        <ProtectedRoute requiredRole="client">
          <AccountPage />
        </ProtectedRoute>
      } />

      <Route path="/subscribers/proposals" element={
        <ProtectedRoute requiredRole="client">
          <Proposals />
        </ProtectedRoute>
      } />

      <Route path="/subscribers/proposals/create-order/:id" element={
        <ProtectedRoute requiredRole="client">
          <CreateOrder />
        </ProtectedRoute>
      } />

      <Route path="/subscribers/orders" element={
        <ProtectedRoute requiredRole="client">
          <Orders />
        </ProtectedRoute>
      } />



      <Route path="/revshare/offers" element={
        <ProtectedRoute requiredRole="client">
          <RevshareOffers />
        </ProtectedRoute>
      } />

      <Route path="/revshare/campaigns" element={
        <ProtectedRoute requiredRole="client">
          <RevshareCampaigns />
        </ProtectedRoute>
      } />

      <Route path="/revshare/bills" element={
        <ProtectedRoute requiredRole="client">
          <RevshareBills />
        </ProtectedRoute>
      } />

      <Route path="/statistics" element={
        <ProtectedRoute requiredRole="client">
          <Statistics />
        </ProtectedRoute>
      } />

      <Route path="/statistics/subscribers" element={
        <ProtectedRoute requiredRole="client">
          <Subscribers />
        </ProtectedRoute>
      } />

      <Route path="/statistics/transactions" element={
        <ProtectedRoute requiredRole="client">
          <Transactions />
        </ProtectedRoute>
      } />

      <Route path="/account" element={
        <ProtectedRoute requiredRole="client">
          <Account />
        </ProtectedRoute>
      } />

      <Route path="/account/wallet" element={
        <ProtectedRoute requiredRole="client">
          <Wallet />
        </ProtectedRoute>
      } />

      <Route path="/account/settings" element={
        <ProtectedRoute requiredRole="client">
          <Settings />
        </ProtectedRoute>
      } />
    </Routes>
  );
};

export default ClientRoutes;
